<template>
  <div class="py-6 px-8">
    <h-header :back="returnRoute" />
    <v-card elevation="0" outlined>
      <div class="pa-5">
        <v-row>
          <v-col cols="12" sm="4" lg="2">
            <h6 class="text-uppercase grey--text">
              {{ $t('contract.label.realEstate') }}
            </h6>
            <span v-if="contract.real_estate">
              {{ contract.real_estate.name }}
            </span>
            <span v-else>---</span>
          </v-col>
          <v-col cols="12" sm="4" lg="2">
            <h6 class="text-uppercase grey--text">
              {{ $t('contract.label.createdBy') }}
            </h6>
            <span v-if="contract.created_by">
              {{ contract.created_by.username }}
            </span>
            <span v-else>---</span>
          </v-col>
          <v-col cols="12" sm="4" lg="2">
            <h6 class="text-uppercase grey--text">
              {{ $t('contract.label.type') }}
            </h6>
            <span v-if="contract.type">
              {{ $t(`contract.label.subscriptionTypes.${contract.type}`) }}
            </span>
            <span v-else>---</span>
          </v-col>
          <v-col cols="12" sm="4" lg="2">
            <h6 class="text-uppercase grey--text">
              {{ $t('contract.label.startDate') }}
            </h6>
            <span v-if="contract.start_date">
              {{ formatDate(contract.start_date) }}
            </span>
            <span v-else>---</span>
          </v-col>
          <v-col cols="12" sm="4" lg="2">
            <h6 class="text-uppercase grey--text">
              {{ $t('contract.label.endDate') }}
            </h6>
            <span v-if="contract.end_date">
              {{ formatDate(contract.end_date) }}
            </span>
            <span v-else>---</span>
          </v-col>
          <v-col cols="12" sm="4" lg="2">
            <h6 class="text-uppercase grey--text">
              {{ $t('contract.label.monthlyCapacity') }}
            </h6>
            <span v-if="contract.monthly_capacity">
              {{ contract.monthly_capacity }}
            </span>
            <span v-else>---</span>
          </v-col>
          <v-col cols="12" sm="4" lg="2">
            <h6 class="text-uppercase grey--text">
              {{ $t('contract.label.monthlyAmount') }}
            </h6>
            <span v-if="contract.daily_capacity">
              {{ contract.daily_capacity }}
            </span>
            <span v-else>---</span>
          </v-col>
          <v-col cols="12" sm="4" lg="2">
            <h6 class="text-uppercase grey--text">
              {{ $t('contract.label.overuseFee') }}
            </h6>
            <span v-if="contract.overuse_fee">
              {{ formatMoney(contract.overuse_fee) }}
            </span>
            <span v-else>---</span>
          </v-col>
        </v-row>

        <v-divider class="mt-5 mb-8" />

        <h3 class="mb-5">
          {{ $t('contract.details.services') }}
        </h3>

        <div v-for="serviceContract in contract.service_contracts" :key="serviceContract.type">
          <h4>
            {{ $t(`appointment.type.${serviceContract.type}`) }}
          </h4>

          <v-row>
            <v-col cols="12" md="4" lg="2">
              <h6 class="text-uppercase grey--text">
                {{ $t('contract.details.price') }}
              </h6>
              <span v-if="serviceContract.price">
                {{ formatMoney(serviceContract.price) }}
              </span>
              <span v-else>---</span>
            </v-col>
            <v-col cols="12" md="4" lg="2">
              <h6 class="text-uppercase grey--text">
                {{ $t('contract.details.hostTax') }}%
              </h6>
              <span v-if="serviceContract.host_tax">
                {{ serviceContract.host_tax }}%
              </span>
              <span v-else>---</span>
            </v-col>
            <v-col cols="12" md="4" lg="2">
              <h6 class="text-uppercase grey--text">
                {{ $t('contract.details.discount') }}
              </h6>
              <span v-if="serviceContract.discount">
                {{ serviceContract.discount }}%
              </span>
              <span v-else>---</span>
            </v-col>
            <v-col cols="12" md="4" lg="2">
              <h6 class="text-uppercase grey--text">
                {{ $t('contract.details.squareMetersPrice') }}
              </h6>
              <span v-if="serviceContract.square_meter_price">
                {{ formatMoney(serviceContract.square_meter_price) }}
              </span>
              <span v-else>---</span>
            </v-col>
            <v-col cols="12" md="4" lg="2">
              <h6 class="text-uppercase grey--text">
                {{ $t('contract.details.squareMetersTax') }}
              </h6>
              <span v-if="serviceContract.square_meter_tax">
                {{ serviceContract.square_meter_tax }}%
              </span>
              <span v-else>---</span>
            </v-col>
            <v-col cols="12" md="4" lg="2">
              <h6 class="text-uppercase grey--text">
                {{ $t('contract.details.baseSquareMetersPrice') }}
              </h6>
              <span v-if="serviceContract.base_square_meters_size">
                {{ serviceContract.base_square_meters_size }}m²
              </span>
              <span v-else>---</span>
            </v-col>
            <v-col cols="12" md="4" lg="2">
              <h6 class="text-uppercase grey--text">
                {{ $t('contract.details.furnitureTax') }}
              </h6>
              <span v-if="serviceContract.furniture_tax">
                {{ serviceContract.furniture_tax }}%
              </span>
              <span v-else>---</span>
            </v-col>
            <v-col cols="12" md="4" lg="2">
              <h6 class="text-uppercase grey--text">
                {{ $t('contract.details.semiFurnitureTax') }}
              </h6>
              <span v-if="serviceContract.semi_furniture_tax">
                {{ serviceContract.semi_furniture_tax }}%
              </span>
              <span v-else>---</span>
            </v-col>
            <v-col cols="12" md="4" lg="2">
              <h6 class="text-uppercase grey--text">
                {{ $t('contract.details.houseTax') }}
              </h6>
              <span v-if="serviceContract.house_tax">
                {{ serviceContract.house_tax }}%
              </span>
              <span v-else>---</span>
            </v-col>
            <v-col cols="12" md="4" lg="2">
              <h6 class="text-uppercase grey--text">
               {{ $t('contract.details.trousseauTax') }}
              </h6>
              <span v-if="serviceContract.trousseau_tax">
                {{ serviceContract.trousseau_tax }}%
              </span>
              <span v-else>---</span>
            </v-col>
            <v-col cols="12" md="4" lg="2">
              <h6 class="text-uppercase grey--text">
                {{ $t('contract.details.displacementTax') }}
              </h6>
              <span v-if="serviceContract.displacement_tax">
                {{ serviceContract.displacement_tax }}%
              </span>
              <span v-else>---</span>
            </v-col>
            <v-col cols="12" md="4" lg="3">
              <h6 class="text-uppercase grey--text">
                {{ $t('contract.details.hostRealtyFeatureTax') }}
              </h6>
              <span v-if="serviceContract.host_realty_feature_tax">
                {{ serviceContract.host_realty_feature_tax }}%
              </span>
              <span v-else>---</span>
            </v-col>
            <v-col cols="12" md="4" lg="3">
              <h6 class="text-uppercase grey--text">
                {{ $t('contract.details.urgencyTax') }}
              </h6>
              <span v-if="serviceContract.urgency_tax">
                {{ serviceContract.urgency_tax }}%
              </span>
              <span v-else>---</span>
            </v-col>
            <v-col cols="12" md="4" lg="3">
              <h6 class="text-uppercase grey--text">
                {{ $t('contract.details.hostUrgencyTax') }}
              </h6>
              <span v-if="serviceContract.urgency_tax && serviceContract.urgency_tax > 0">
                {{ serviceContract.host_urgency_tax }}%
              </span>
              <span v-else>---</span>
            </v-col>
            <v-col cols="12" md="4" lg="3">
              <h6 class="text-uppercase grey--text">
                {{ $t('contract.details.urgencyHoursLimit') }}
              </h6>
              <span v-if="serviceContract.urgency_tax && serviceContract.urgency_tax > 0">
                {{ serviceContract.urgency_hours_limit }}h
              </span>
              <span v-else>---</span>
            </v-col>
          </v-row>

          <v-divider v-if="contract.service_contracts.length >= 2" class="mt-5 mb-8" />
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { catalogMonetary, catalogDateWithoutTime } from '@/util/catalog'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ContractDetails',

  computed: {
    ...mapGetters(['isLoading', 'contract']),
  },

  methods: {
    ...mapActions(['fetchContract']),
  },

  mounted() {
    const id = this.$router?.currentRoute?.params?.id
    this.fetchContract(id)
  },

  data() {
    return {
      formatMoney: catalogMonetary,
      returnRoute: `../real-estate-contracts/${this.contract?.real_estate?.id}`,
      formatDate: catalogDateWithoutTime,
    }
  },

  // get last route visited
  // used at the line 3 of this very component
  // vm is used because the VDom do no exists yet
  beforeRouteEnter(to, from, next) {
    next((vm) => vm && (vm.returnRoute = from.fullPath))
  },
}
</script>
